import { ensureJobCorn } from '@eigtech/restoration-util'
import { withRequiredPermissions } from '@/lib/permissions'
import { getUserCohort, useAuth0 } from '@eigtech/ui-shared-auth'
import { UploadDocuments } from '@eigtech/ui-shared-documents-web'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/upload')({
  component: () => <AuthGuard />,
})

const AuthGuard = withRequiredPermissions(JobDetailUploadDocuments, {
  requiredPermissions: [
    { action: 'read', subject: 'document' },
    { action: 'create', subject: 'document' },
  ],
})

function JobDetailUploadDocuments() {
  const { jobId } = Route.useParams()

  const { user } = useAuth0()
  // delegate component, default to technician cohort
  const cohort = getUserCohort(user) ?? 'technician'

  return <UploadDocuments cohort={cohort} entityId={ensureJobCorn(jobId)} />
}
